import React from 'react'
import { Link } from 'react-router-dom'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faPhoneAlt, faCog, faChartPie, faBook } from '@fortawesome/free-solid-svg-icons';


const DebitMenu = ({defaultMainMenuStyle, role, mainMenu, subMenu}) => {
    const accountMenu = [];
    // accountMenu.push(<Link key="0" to="/announce" className={mainMenu==="account" && subMenu==="overview"?"submenu-active" : ""}>OVERVIEW</Link>);
    if (role.includes("DD_ACCOUNT_PROFILE")) {
        accountMenu.push(<Link key="1" to="/merchant/view" className={mainMenu==="account" && subMenu==="profile"?"submenu-active" : ""}>PROFILE</Link>);
    }
    if (role.includes("DD_ACCOUNT_USER")) {
        accountMenu.push(<Link key="2" to="/user" className={mainMenu==="account" && subMenu==="user"?"submenu-active" : ""}>USER</Link>);
    }
    if (role.includes("DD_ACCOUNT_CUSTOMER_PROFILE")) {
        accountMenu.push(<Link key="3" to="/customer" className={mainMenu==="account" && subMenu==="customer"?"submenu-active" : ""}>CUSTOMER</Link>);
    }

    const generalReportMenu=[];
    if (role.includes("DD_REPORT_TRANSACTION")) {
        generalReportMenu.push(<Link key="1" to="/reports/transactions/online" className={mainMenu==="reports" && subMenu==="transaction"?"submenu-active" : ""}>TRANSACTION</Link>);
    }

    if (role.includes("DD_REPORT_REGISTRATION")) {
        generalReportMenu.push(<Link key="2" to="/reports/registration" className={mainMenu==="reports" && subMenu==="registration"?"submenu-active" : ""}>REGISTRATION</Link>);
    }

    if (role.includes("DD_REPORT_ONLINE_REGISTRATION")) {
        generalReportMenu.push(<Link key="3" to="/reports/online-registration-monitoring" className={mainMenu==="reports" && subMenu==="onlineRegistration"?"submenu-active" : ""}>ONLINE REGISTRATION MONITORING</Link>);
    }

    if (role.includes("SSO")) {
        generalReportMenu.push(<Link key="4" to="/reports/sso-250-bytes" className={mainMenu==="reports" && subMenu==="sso250Bytes"?"submenu-active" : ""}>SSO TEXT FILE FORMAT 250 BYTES</Link>);
    }


    const userManualMenu = 
        <Link key="contact"
            className={defaultMainMenuStyle + (mainMenu==="manual"?" mainmenu-active" : "")}
            to="/manual"><FontAwesomeIcon icon={faBook} className="mr-2"/>
            USER MANUAL
        </Link>
    
    const contactMenu=[];
        contactMenu.push(
            <Link key="contact"
                className={defaultMainMenuStyle + (mainMenu==="contact"?" mainmenu-active" : "")}
                to="/contact"><FontAwesomeIcon icon={faPhoneAlt} className="mr-2"/>
                CONTACT US
            </Link>
        );

    return (
        <div className="navmain p-0">
            {accountMenu.length!==0 &&
                <div className="subnav p-0">
                    <a href="#" className={defaultMainMenuStyle + (mainMenu==="account"?" mainmenu-active" : "")}><FontAwesomeIcon icon={faUser} className="mr-2"/>ACCOUNT</a>
                    <div className="subnav-content">
                        {accountMenu}
                    </div>
                </div>  
            }
            {generalReportMenu.length!==0 &&
            <div className="subnav p-0">
                <a href="#" className={defaultMainMenuStyle + (mainMenu==="reports"?" mainmenu-active" : "")}><FontAwesomeIcon icon={faChartPie} className="mr-2"/> REPORTS</a>
                <div className="subnav-content">
                    {generalReportMenu}
                </div>
            </div>
            }
            {userManualMenu}
            {contactMenu}
        </div>
    )
}

export default DebitMenu
